import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const Google = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon {...props} ref={ref} viewBox="0 0 24 24">
    <path
      d="M22.7663 12.2475C22.7663 11.5233 22.7021 10.8358 22.5921 10.1666H12.2338V14.3008H18.1646C17.8988 15.6575 17.1196 16.8033 15.9646 17.5825V20.3325H19.5029C21.5746 18.4166 22.7663 15.5933 22.7663 12.2475Z"
      fill="#4285F4"
    />
    <path
      d="M12.2338 23C15.2038 23 17.6879 22.01 19.5029 20.3325L15.9646 17.5825C14.9746 18.2425 13.7188 18.6458 12.2338 18.6458C9.36459 18.6458 6.93543 16.7116 6.06459 14.0991H2.41626V16.9316C4.22209 20.525 7.93459 23 12.2338 23Z"
      fill="#34A853"
    />
    <path
      d="M6.0646 14.0992C5.83543 13.4392 5.71626 12.7334 5.71626 12C5.71626 11.2667 5.8446 10.5609 6.0646 9.90086V7.06836H2.41626C1.6646 8.55336 1.23376 10.2217 1.23376 12C1.23376 13.7784 1.6646 15.4467 2.41626 16.9317L6.0646 14.0992Z"
      fill="#FBBC05"
    />
    <path
      d="M12.2338 5.35417C13.8563 5.35417 15.3046 5.91334 16.4504 7.00417L19.5854 3.86917C17.6879 2.09083 15.2038 1 12.2338 1C7.93459 1 4.22209 3.475 2.41626 7.06834L6.06459 9.90084C6.93543 7.28834 9.36459 5.35417 12.2338 5.35417Z"
      fill="#EA4335"
    />
  </SvgIcon>
));

Google.displayName = 'Google';

export default Google;
